function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { moveHighlight, listReducer, ListActionTypes, handleItemSelection } from "../useList/index.js";
import { SelectActionTypes } from "./useSelect.types.js";
export function selectReducer(state, action) {
    var open = state.open;
    var selectionMode = action.context.selectionMode;
    if (action.type === SelectActionTypes.buttonClick) {
        var _state_selectedValues_;
        var itemToHighlight = (_state_selectedValues_ = state.selectedValues[0]) !== null && _state_selectedValues_ !== void 0 ? _state_selectedValues_ : moveHighlight(null, 'start', action.context);
        return _object_spread_props(_object_spread({}, state), {
            open: !open,
            highlightedValue: !open ? itemToHighlight : null
        });
    }
    if (action.type === SelectActionTypes.browserAutoFill) {
        return handleItemSelection(action.item, state, action.context);
    }
    var newState = listReducer(state, action);
    switch(action.type){
        case ListActionTypes.keyDown:
            if (state.open) {
                if (action.event.key === 'Escape') {
                    return _object_spread_props(_object_spread({}, newState), {
                        open: false
                    });
                }
            } else {
                if (action.event.key === 'ArrowDown') {
                    var _state_selectedValues_1;
                    return _object_spread_props(_object_spread({}, state), {
                        open: true,
                        highlightedValue: (_state_selectedValues_1 = state.selectedValues[0]) !== null && _state_selectedValues_1 !== void 0 ? _state_selectedValues_1 : moveHighlight(null, 'start', action.context)
                    });
                }
                if (action.event.key === 'ArrowUp') {
                    var _state_selectedValues_2;
                    return _object_spread_props(_object_spread({}, state), {
                        open: true,
                        highlightedValue: (_state_selectedValues_2 = state.selectedValues[0]) !== null && _state_selectedValues_2 !== void 0 ? _state_selectedValues_2 : moveHighlight(null, 'end', action.context)
                    });
                }
            }
            break;
        case ListActionTypes.itemClick:
            if (selectionMode === 'single') {
                return _object_spread_props(_object_spread({}, newState), {
                    open: false
                });
            }
            break;
        case ListActionTypes.blur:
            return _object_spread_props(_object_spread({}, newState), {
                open: false
            });
        default:
            return newState;
    }
    return newState;
}
